import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { select, Store } from '@ngrx/store';
import { GetReferralProfileTemplate, getReferralUser, PublicState, ResetPublicState } from '@frontend/public-store';
import { Subject, takeUntil } from 'rxjs';

@Component({
  selector: 'frontend-referral-page',
  templateUrl: './referral-page.component.html',
  styleUrls: ['./referral-page.component.scss'],
})
export class ReferralPageComponent implements OnInit {
  unsubscriber = new Subject();
  inviteUser: any;
  constructor(
    private route: ActivatedRoute,
    private store: Store,
    private publicStore: Store<PublicState>
  ) {
    this.publicStore.dispatch(
      ResetPublicState({ params: { error: '', success: '' } })
    );

    this.publicStore
      .pipe(select(getReferralUser))
      .pipe(takeUntil(this.unsubscriber))
      .subscribe((invite) => {
        if (invite) {
          this.inviteUser = invite;
        }
      });
  }

  ngOnInit(): void {
    const invite = this.route.snapshot.queryParamMap.get('invite');
    if (invite) {
      this.store.dispatch(GetReferralProfileTemplate({ code: invite }));
    }
  }

  encodeUrl(url: string): string {
    return encodeURIComponent(url);
  }
}
